// extracted by mini-css-extract-plugin
export default {"table":"Table_table__acU+P","name":"Table_name__6Xh5Z","email":"Table_email__H53w-"};